import { tokens } from '@arvoreeducacao/bonsai-ds'
import { USERS_TABLE_WRAPPER_ID } from 'components/admin/entity-users-management/UserTable/UsersTable'
import styled from 'styled-components'

type WrapperSidebarProps = {
  isOpen?: boolean
  collapsed?: boolean
}

export const WrapperSidebar = styled.div<WrapperSidebarProps>`
  gap: ${tokens.spacing.insetXsmall};
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0px;
  top: 0px;
  min-width: ${props => (props.collapsed ? '64px' : '248px')};
  height: 100vh;
  flex-shrink: 0;
  background-color: ${tokens.colors.dark6};
  padding: ${tokens.spacing.insetXsmall};
  overflow-y: auto;
  overflow-x: hidden;
  max-width: ${props => (props.collapsed ? '64px' : '248px')};
  z-index: 10;
  transition: min-width 0.2s ease-in-out, max-width 0.2s ease-in-out;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    top: 70px;
    height: calc(100vh - 70px);
  }

  @media (max-width: ${tokens.breakpoints.desktop - 1}px) {
    top: 56px;
    height: calc(100vh - 56px);
    min-width: 248px;
    max-width: 248px;
    transform: ${props =>
      props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.25s ease-in-out;
    z-index: 20;
    box-shadow: ${props => (props.isOpen ? tokens.shadows.downLarge : 'none')};
  }

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    body:has(#${USERS_TABLE_WRAPPER_ID}) & {
      display: ${props => (props.isOpen ? 'flex' : 'none')};
    }
  }
`

export const SidebarOverlay = styled.div<WrapperSidebarProps>`
  display: none;

  @media (max-width: ${tokens.breakpoints.desktop - 1}px) {
    display: ${props => (props.isOpen ? 'block' : 'none')};
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 19;
  }
`

export const SidebarV2Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${tokens.spacing.insetXsmall};
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
`

export const SidebarV2Footer = styled.div`
  margin-top: auto;
  padding-top: ${tokens.spacing.insetSmall};
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;
`

export const CollapseToggleButton = styled.button<{ collapsed?: boolean }>`
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: ${tokens.radius.medium};
  margin-top: ${({ collapsed }) => (collapsed ? '8px' : '8px')};
  cursor: pointer;
  align-self: ${({ collapsed }) => (collapsed ? 'center' : 'center')};
  flex-shrink: 0;
  padding: 0;

  &:hover {
    background-color: ${tokens.colors.dark5};
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    display: flex;
  }
`
